/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_SpendInputs */

const vi_shop_account_col_spend = /** @type {(inputs: Shop_Account_Col_SpendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiêu`)
};

/**

* @param {Shop_Account_Col_SpendInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_spend = /** @type {((inputs?: Shop_Account_Col_SpendInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_SpendInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_spend(inputs)
});